import { render } from "./FeatureCard.vue?vue&type=template&id=5aafa892&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"

import "./FeatureCard.vue?vue&type=style&index=0&id=5aafa892&scoped=true&lang=css"
import "./FeatureCard.vue?vue&type=style&index=1&id=5aafa892&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aafa892"]])

export default __exports__